import { render } from "./dependent-provider-age-warning.vue?vue&type=template&id=3151a5fe&scoped=true"
const script = {}

import "./dependent-provider-age-warning.vue?vue&type=style&index=0&id=3151a5fe&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3151a5fe"]])

export default __exports__